const RETURN_URL_KEY = '__return_url__';

export const saveReturnUrl = (url) => {
    // Don't save login/registration pages as return URLs
    if (url && !url.includes('/login') && !url.includes('/registration') && !url.includes('/forgot-password')) {
        sessionStorage.setItem(RETURN_URL_KEY, url);
    }
};

export const getReturnUrl = () => {
    return sessionStorage.getItem(RETURN_URL_KEY);
};

export const clearReturnUrl = () => {
    sessionStorage.removeItem(RETURN_URL_KEY);
};
